"use client";
import { useEffect } from "react";
import { useSearchParams, useRouter, usePathname } from "next/navigation";
import { toast } from "react-hot-toast";

export function UnauthorizedToastListener() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const isUnauthorized = searchParams.get("unauthorized");

    if (isUnauthorized) {
      // 1. Trigger the toast notification
      toast.error(
        "You are not authorized to access that page. Please log in first.",
        {
          id: "unauthorized-toast",
        },
      );

      // 2. Clean up the URL query parameter without refreshing the page
      const params = new URLSearchParams(searchParams.toString());
      params.delete("unauthorized");

      const newUrl = params.toString()
        ? `${pathname}?${params.toString()}`
        : pathname;
      router.replace(newUrl, { scroll: false });
    }
  }, [searchParams, router, pathname]);

  return null;
}
